document.addEventListener('click', function (ev) {
  var t = ev.target.closest('[data-ixs-tab], [data-ixs-more]');
  if (!t) return;
  var cat = t.closest('[data-ixs-catalog]');
  if (cat) cat.classList.add('is-all');
});
(function () {
  var filterThumbs = function (root, isClick) {
    var sw = root.querySelector('.ixs-swatch.is-on[data-ixs-opt]');
    if (!sw) return;
    var c = sw.getAttribute('data-value');
    var first = null;
    root.querySelectorAll('[data-ixs-thumb]').forEach(function (t) {
      var tc = t.getAttribute('data-color');
      var show = !tc || tc === c;
      t.style.display = show ? '' : 'none';
      if (tc === c && !first) first = t;
    });
    if (!isClick || root.__ixsColor === c) { root.__ixsColor = c; return; }
    root.__ixsColor = c;
    var hasOwn = false;
    try {
      var id = Number((root.querySelector('[data-ixs-id]') || {}).value);
      var data = JSON.parse(root.querySelector('[data-ixs-variants]').textContent);
      var v = data.find(function (x) { return x.id === id; });
      hasOwn = !!(v && v.featured_media);
    } catch (e) {}
    var img = root.querySelector('[data-ixs-main-img]');
    if (img && first && !hasOwn) { img.src = first.getAttribute('data-ixs-thumb'); img.removeAttribute('srcset'); }
  };
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-ixs-opt]');
    if (!b) return;
    var root = b.closest('[data-ixs-product]');
    if (root) setTimeout(function () { filterThumbs(root, true); }, 0);
  });
  var run = function () { document.querySelectorAll('[data-ixs-product]').forEach(function (r) { filterThumbs(r, false); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* Quita el fondo blanco/gris de las fotos de producto y las recorta */
(function () {
  var SEL = '.ixs-cat-img img, .ixs-tile img, [data-ixs-main-img], .ixs-thumbs img, .ixs-hero img';
  var cache = {};
  var done = function (img) { img.classList.add('is-cut'); };
  var process = function (url) {
    if (cache[url]) return cache[url];
    cache[url] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onerror = function () { resolve(null); };
      im.onload = function () {
        try {
          var W = im.naturalWidth, H = im.naturalHeight;
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, W, H), p = d.data, N = W * H;
          var like = new Uint8Array(N), i;
          for (i = 0; i < N; i++) {
            var r = p[i * 4], g = p[i * 4 + 1], b = p[i * 4 + 2];
            var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
            like[i] = (mn >= 236 && mx - mn <= 12) ? 1 : 0;
          }
          var edge = 0, tot = 0, k;
          for (k = 0; k < W; k += 2) { edge += like[k] + like[(H - 1) * W + k]; tot += 2; }
          for (k = 0; k < H; k += 2) { edge += like[k * W] + like[k * W + W - 1]; tot += 2; }
          if (edge / tot < 0.92) { resolve(null); return; }
          var bg = new Uint8Array(N), q = new Int32Array(N), h = 0, t = 0;
          var push = function (j) { if (like[j] && !bg[j]) { bg[j] = 1; q[t++] = j; } };
          for (k = 0; k < W; k++) { push(k); push((H - 1) * W + k); }
          for (k = 0; k < H; k++) { push(k * W); push(k * W + W - 1); }
          while (h < t) { var j = q[h++], xx = j % W, yy = (j / W) | 0;
            if (xx > 0) push(j - 1); if (xx < W - 1) push(j + 1); if (yy > 0) push(j - W); if (yy < H - 1) push(j + W); }
          var minX = W, minY = H, maxX = 0, maxY = 0;
          for (i = 0; i < N; i++) {
            if (bg[i]) { p[i * 4 + 3] = 0; continue; }
            var px = i % W, py = (i / W) | 0;
            if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py;
            if ((px > 0 && bg[i - 1]) || (px < W - 1 && bg[i + 1]) || (py > 0 && bg[i - W]) || (py < H - 1 && bg[i + W])) {
              var m2 = Math.min(p[i * 4], p[i * 4 + 1], p[i * 4 + 2]);
              if (m2 > 200) p[i * 4 + 3] = Math.max(0, Math.min(255, Math.round((255 - m2) * 255 / 55)));
            }
          }
          if (maxX <= minX || maxY <= minY) { resolve(null); return; }
          x.putImageData(d, 0, 0);
          var pad = Math.round(Math.max(maxX - minX, maxY - minY) * 0.03);
          minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad); maxX = Math.min(W - 1, maxX + pad); maxY = Math.min(H - 1, maxY + pad);
          var o = document.createElement('canvas'); o.width = maxX - minX + 1; o.height = maxY - minY + 1;
          o.getContext('2d').drawImage(c, minX, minY, o.width, o.height, 0, 0, o.width, o.height);
          o.toBlob(function (blob) { resolve(blob ? URL.createObjectURL(blob) : null); }, 'image/png');
        } catch (e) { resolve(null); }
      };
      im.src = url;
    });
    return cache[url];
  };
  var sized = function (src, w) {
    if (src.indexOf('cdn.shopify.com') < 0 && src.indexOf('/cdn/shop/') < 0) return null;
    var u = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&ixcut=1';
  };
  var cut = function (img) {
    var src = img.getAttribute('src') || '';
    if (!src || src.indexOf('blob:') === 0) { done(img); return; }
    if (img.__ixSrc === src) return;
    img.__ixSrc = src;
    img.classList.remove('is-cut');
    var big = img.hasAttribute('data-ixs-main-img') || img.closest('.ixs-hero');
    var url = sized(src.indexOf('//') === 0 ? 'https:' + src : src, big ? 1400 : 700);
    if (!url) { done(img); return; }
    process(url).then(function (blob) {
      if (img.__ixSrc !== src) return;
      if (blob) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.__ixSrc = blob; img.src = blob; img.style.objectFit = 'contain'; }
      done(img);
    });
  };
  var run = function (scope) { (scope || document).querySelectorAll(SEL).forEach(cut); };
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) { if (m.type === 'attributes' && m.target.matches && m.target.matches(SEL)) cut(m.target); });
  });
  var start = function () {
    run();
    mo.observe(document.body, { attributes: true, attributeFilter: ['src'], subtree: true });
    setTimeout(function () { document.querySelectorAll(SEL).forEach(done); }, 4000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
